import { type Invitation } from './invitation';

export enum UserRole {
    UNKNOWN = "UNKNOWN",
    GUEST = "GUEST",
    COMPETITOR = "COMPETITOR",
    ORGANIZER = "ORGANIZER"
}

export enum SubscriptionLevel {
    NONE = "NONE",
    STUDENT = "STUDENT",
    PRO = "PRO",
    ORGANIZER = "ORGANIZER"
};

export enum SubscriptionStatus {
    NONE = "NONE",
    EXPIRED = "EXPIRED",
    TRIAL = "TRIAL",
    ACTIVE = "ACTIVE",
};

export type Subscription = {
    id: string;                 // primary key relates to id of users table   
    email: string;   
    type: SubscriptionLevel;
    status: SubscriptionStatus;
    customerId?: string;        // Stripe customer ID
    subscriptionId?: string;    // Stripe subscription ID
    priceId?: string;           // Stripe price ID
    expiration?: string;
    trialExpiration?: string;
    prevSubscription?: boolean;
}

export interface ProfileInitialization {
    initialized: boolean;
}

export interface Identity {
    email: string;
    first?: string;
    last?: string;
    picture?: string;
}

export interface Profile extends Identity {
    id: string;
    verified: boolean;
    role: UserRole;
    subscription: Subscription;
    // auth0Sub?: string;
    clerkId?: string;
    invitations?: Invitation[];
    location?: string;
    bio?: string;
    initialized?: boolean;
    created: string;
    updated: string;
}
